var map = {
	"./1.jpg": "cc75",
	"./2.jpg": "cde1",
	"./3.jpg": "a7b0",
	"./4.jpg": "3465",
	"./5.jpg": "37cc",
	"./6.jpg": "c933",
	"./banner.jpg": "8128"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c5b";